function MediaMetadataError(htmlMediaElement) {
  this.name = 'Media Metadata Error';

  const problems = [];

  const tagName = htmlMediaElement.tagName;

  if (tagName === 'VIDEO') {
    const { videoWidth, videoHeight, duration } = htmlMediaElement;
    if (!videoWidth) problems.push('videoWidth');
    if (!videoHeight) problems.push('videoHeight');
    if (!duration) problems.push('duration');
  } else {
    const { height, naturalHeight, naturalWidth, width } = htmlMediaElement;
    if (!height) problems.push('height');
    if (!naturalHeight) problems.push('naturalHeight');
    if (!naturalWidth) problems.push('naturalWidth');
    if (!width) problems.push('width');
  }

  this.message = `Media ${tagName} missing metadata: ${problems.join(', ')}`;

  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
  this.stack = new Error().stack;
}

MediaMetadataError.prototype = Object.create(Error.prototype);
MediaMetadataError.prototype.constructor = MediaMetadataError;

export default MediaMetadataError;
